export default "__VITE_ASSET__BDPnVVIK__"